module.exports = __webpack_public_path__ + "img/s5.9149e3b0.png";